// @flow
import { paths } from '#navigation/paths';

export type NavigationMenuItem = {
    title: string,
    screenName: string,
    navigationPath: string,
};

export type NavigationMenuItemsGroup = {
    title: string,
    items: NavigationMenuItem[],
};

export type NavigationDeepMenuList = NavigationMenuItemsGroup[];

const showZeroState = false; // !EnvManager.isMainnet();

const navigationMenuItems: NavigationDeepMenuList = [
    {
        title: 'Blockchain',
        items: [
            {
                title: 'Blocks',
                navigationPath: paths.blocks.main,
            },
            {
                title: 'Accounts',
                navigationPath: paths.accounts.main,
            },
            {
                title: 'Messages',
                navigationPath: paths.messages.main,
            },
            {
                title: 'Transactions',
                navigationPath: paths.transactions.main,
            },
        ],
    },
];

if (showZeroState) {
    navigationMenuItems[0].items.push({
        title: 'ZeroState',
        navigationPath: paths.zeroState,
    });
}

export { navigationMenuItems };
